import React, { useState } from 'react';
import {
  AppBar, Toolbar, Typography, Button, Box, Container, Grid, Card, CardContent,
  IconButton, CardMedia,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Menu from '@mui/icons-material/Menu';
import Mail from '@mui/icons-material/Mail';
import Phone from '@mui/icons-material/Phone';
import LocationOn from '@mui/icons-material/LocationOn';
// import { useNavigate } from 'react-router-dom';
import ImageMontage from './ImageMontage';

// Custom dark theme
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#FFCE18' },
    secondary: { main: '#FFA726' },
    background: {
      default: '#0d0d0d',
      paper: '#121212',
    },
    text: {
      primary: '#fff',
      secondary: '#aaa',
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    body1: { color: '#ccc' },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
  },
});

function Webpage() {
  const [currentPage, setCurrentPage] = useState('home');
  const [mobileOpen, setMobileOpen] = useState(false);
  // const navigation = useNavigate();

  const tutors = [
    { id: 1, name: 'Teacher Anis', subject: 'Mathematics', image: require('./images/tutor/Anis.jpeg') },
    { id: 2, name: 'Sir Anwar', subject: 'English & Literature', image: require('./images/tutor/Anwar.jpeg') },
    { id: 3, name: 'Miss Erlia', subject: 'Bahasa Melayu', image: require('./images/tutor/Erlia.jpeg') },
    { id: 4, name: 'Teacher Hidayah', subject: 'Science', image: require('./images/tutor/Dayah.jpeg') },
    { id: 5, name: 'Cikgu Peja', subject: 'Sejarah', image: require('./images/tutor/Peja.jpeg') },
    { id: 6, name: 'Sir Salleh', subject: 'Physics', image: require('./images/tutor/Salleh.jpeg') },
    { id: 7, name: 'Miss Aisyah', subject: 'Accounting & Economics', image: require('./images/tutor/Aisyah.jpeg') },
    { id: 8, name: 'Miss Allysa', subject: 'English & Literature', image: require('./images/tutor/Allysa.jpeg') },
    { id: 9, name: 'Sir Annuar', subject: 'Bahasa Melayu', image: require('./images/tutor/Annuar.jpeg') },
    { id: 10, name: 'Teacher Ain', subject: 'English & Literature', image: require('./images/tutor/Ain.jpeg') },
    { id: 11, name: 'Ustazah Nazihah', subject: 'Admin', image: require('./images/tutor/Ziha.jpeg') },
    { id: 12, name: 'Miss Ain', subject: 'Admin', image: require('./images/tutor/AinIzz.jpeg') },
    { id: 13, name: 'Miss Solehah', subject: 'Admin', image: require('./images/tutor/Solehah.jpeg') },
  ];

  const imageBg = require('./images/home/ptgm-background.jpeg');

  const renderContent = () => {
    switch (currentPage) {
      case 'home':
        return (
          <>
            {/* HERO SECTION */}
            <Box
              sx={{
                position: 'relative',
                backgroundImage: `url(${imageBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: 'white',
                minHeight: { xs: 500, md: 600 },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                px: 2,
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.9))',
                }}
              />
              <Container sx={{ position: 'relative', zIndex: 2 }}>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 700,
                    mb: 3,
                    color: 'white',
                  }}
                >
                  Unlock Your Child's Full Potential
                </Typography>
                <Typography variant="h6" sx={{ mb: 5, color: '#f5f5f5' }}>
                  Personalized learning, expert tutors, and proven results.
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={() => setCurrentPage('contact')}
                  sx={{
                    color: 'black',
                    px: 4,
                    py: 1.5,
                    borderRadius: '8px',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
                    '&:hover': { transform: 'scale(1.05)', backgroundColor: '#FFD633' },
                    transition: '0.3s',
                  }}
                >
                  Enroll Today
                </Button>
              </Container>
            </Box>

            {/* ABOUT SECTION */}
            <Box sx={{ py: 10, bgcolor: 'background.paper' }}>
              <Container maxWidth="md" sx={{ textAlign: 'center' }}>
                <Typography variant="h4" color="primary" sx={{ mb: 4 }}>
                  About Our Center
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                  At Genius Milenia, we believe every student can excel. Our dedicated team of
                  experienced educators provides a supportive environment where students master
                  challenging subjects, think critically, and build confidence.
                </Typography>
              </Container>
            </Box>

            {/* TUTORS SECTION */}
            <Box sx={{ py: 10, backgroundColor: '#0d0d0d' }}>
              <Typography variant="h4" align="center" color="primary" sx={{ mb: 5 }}>
                Meet Our Expert Tutors
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  overflowX: 'auto',
                  gap: 3,
                  px: 4,
                  pb: 4,
                  '&::-webkit-scrollbar': { display: 'none' },
                }}
              >
                {tutors.map((tutor) => (
                  <Card
                    key={tutor.id}
                    sx={{
                      flexShrink: 0,
                      width: 250,
                      backgroundColor: '#1a1a1a',
                      borderRadius: '1rem',
                      overflow: 'hidden',
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={tutor.image}
                      alt={tutor.name}
                      sx={{ height: 250, objectFit: 'cover' }}
                    />
                    <CardContent sx={{ textAlign: 'center' }}>
                      <Typography variant="h6" color="white">
                        {tutor.name}
                      </Typography>
                      <Typography variant="body2" color="primary">
                        {tutor.subject}
                      </Typography>
                    </CardContent>
                  </Card>
                ))}
              </Box>
            </Box>

            {/* TESTIMONIALS */}
            <Box sx={{ py: 10, bgcolor: '#121212' }}>
              <Container maxWidth="lg">
                <Typography variant="h4" align="center" color="primary" sx={{ mb: 8 }}>
                  What Our Parents Say
                </Typography>
                <Grid container spacing={4} justifyContent="center">
                  <Grid item xs={12} md={6}>
                    <Card sx={{ p: 3, backgroundColor: '#1e1e1e' }}>
                      <Typography variant="body1" sx={{ fontStyle: 'italic', mb: 3 }}>
                        "Salam teacher, alhamdulillah aqeef dpt 3 anugerah pbd dan auni dpt 2 anugerah pbd tahun lepas"
                      </Typography>
                      <Typography variant="subtitle1" sx={{ textAlign: 'right', color: '#FFCE18' }}>
                        - Encik Khairul
                      </Typography>
                    </Card>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Card sx={{ p: 3, backgroundColor: '#1e1e1e' }}>
                      <Typography variant="body1" sx={{ fontStyle: 'italic', mb: 3 }}>
                        "Cikgu-cikgu mengajar best katanya. Saya sebagai ibu juga mmg nampak perubahan dan improvement dalam pelajaran anak-anak"
                      </Typography>
                      <Typography variant="subtitle1" sx={{ textAlign: 'right', color: '#FFCE18' }}>
                        - Puan Aisyah
                      </Typography>
                    </Card>
                  </Grid>
                </Grid>
              </Container>
              {/* SQUARE MONTAGE SECTION */}
              <ImageMontage
                images={[
                  './images/testimonies/student1.jpeg',
                  './images/testimonies/student2.jpeg',
                  './images/testimonies/student3.jpeg',
                  './images/testimonies/student4.jpeg',
                  './images/testimonies/testimonies1.jpeg',
                  './images/testimonies/testimonies2.jpeg',
                ]}
              />
            </Box>
          </>
        );

      case 'about':
        return (
          <Box sx={{ py: { xs: 8, md: 16 }, px: 2, bgcolor: 'background.paper', minHeight: 'calc(100vh - 64px - 100px)' }}>
            <Container maxWidth="md" sx={{ textAlign: 'center' }}>
              <Typography variant="h4" sx={{ mb: 6, color: 'primary.main' }}>About Genius Milenia</Typography>
              <Typography variant="body1" sx={{ fontSize: '1.125rem', lineHeight: '1.625', mb: 4 }}>
                Founded in 2018, Genius Milenia was established with a clear mission: to provide high-quality, personalized tuition that empowers students to achieve their academic goals and beyond. We understand that every student learns differently, which is why our programs are tailored to individual needs, learning styles, and paces.
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1.125rem', lineHeight: '1.625' }}>
                Our team comprises highly qualified and passionate educators who are experts in their respective fields. They bring not only subject matter mastery but also a deep understanding of pedagogical techniques to foster a love for learning. We pride ourselves on creating a positive, encouraging, and challenging environment that inspires students to reach for excellence.
              </Typography>
            </Container>

            {/* SQUARE MONTAGE SECTION */}
            <ImageMontage
              images={[
                './images/testimonies/student1.jpeg',
                './images/testimonies/student2.jpeg',
                './images/testimonies/student3.jpeg',
                './images/testimonies/student4.jpeg',
                './images/testimonies/testimonies1.jpeg',
                './images/testimonies/testimonies2.jpeg',
              ]}
            />
          </Box>
        );

      case 'services':
        return (
          <Box sx={{ py: { xs: 8, md: 12 }, px: 2, bgcolor: '#0d0d0d', minHeight: 'calc(100vh - 64px - 100px)' }}>
            <Container maxWidth="lg">
              <Typography variant="h4" sx={{ textAlign: 'center', mb: 8, color: 'primary.main' }}>Our Comprehensive Services</Typography>
              <Grid container spacing={4} justifyContent="center">
                <Grid item xs={12} sm={6} md={4}>
                  <Card sx={{ height: '100%', bgcolor: '#1b1b1b' }}>
                    <CardContent sx={{ p: 3 }}>
                      <Typography variant="h5" sx={{ mb: 1.5, color: 'primary.main' }}>Individualized Tutoring</Typography>
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        One-on-one sessions tailored to the student's specific academic needs and learning pace. Ideal for focused attention and deep understanding.
                      </Typography>
                      <Box component="ul" sx={{ listStyleType: 'disc', pl: 2, color: 'text.secondary' }}>
                        <li>Customized lesson plans</li>
                        <li>Targeted subject assistance</li>
                        <li>Flexible scheduling</li>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Card sx={{ height: '100%', bgcolor: '#1b1b1b' }}>
                    <CardContent sx={{ p: 3 }}>
                      <Typography variant="h5" sx={{ mb: 1.5, color: 'primary.main' }}>Small Group Classes</Typography>
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        Learn collaboratively in small groups (max 5 students). Encourages peer learning while maintaining personalized feedback.
                      </Typography>
                      <Box component="ul" sx={{ listStyleType: 'disc', pl: 2, color: 'text.secondary' }}>
                        <li>Interactive sessions</li>
                        <li>Peer support and motivation</li>
                        <li>Cost-effective learning</li>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Card sx={{ height: '100%', bgcolor: '#1b1b1b' }}>
                    <CardContent sx={{ p: 3 }}>
                      <Typography variant="h5" sx={{ mb: 1.5, color: 'primary.main' }}>Exam Preparation</Typography>
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        Intensive courses to prepare students for major examinations (SPM, IGCSE, SAT). Focus on techniques, past papers, and time management.
                      </Typography>
                      <Box component="ul" sx={{ listStyleType: 'disc', pl: 2, color: 'text.secondary' }}>
                        <li>Strategic content review</li>
                        <li>Practice tests & mock exams</li>
                        <li>Stress management tips</li>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Card sx={{ height: '100%', bgcolor: '#1b1b1b' }}>
                    <CardContent sx={{ p: 3 }}>
                      <Typography variant="h5" sx={{ mb: 1.5, color: 'primary.main' }}>Holiday Programs</Typography>
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        Engaging programs during school holidays to catch up or get ahead for the next academic year.
                      </Typography>
                      <Box component="ul" sx={{ listStyleType: 'disc', pl: 2, color: 'text.secondary' }}>
                        <li>Subject specific workshops</li>
                        <li>Revision and preview sessions</li>
                        <li>Fun and interactive activities</li>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Container>

            {/* MONTAGE IMAGE SECTION */}
            <Typography variant="h4" sx={{ textAlign: 'center', mt: 16, color: 'primary.main' }}>Our Classroom</Typography>
            <ImageMontage
              type='auto'
              images={[
                './images/about/classroom1.jpeg',
                './images/about/classroom2.jpeg',
                './images/about/classroom3.jpeg',
              ]}
            />

          </Box>
        );

      case 'contact':
        return (
          <Box sx={{ py: 10, px: 2, bgcolor: 'background.paper', minHeight: 'calc(100vh - 64px - 100px)' }}>
            <Container maxWidth="md" sx={{ textAlign: 'center' }}>
              <Typography variant="h4" color="primary" sx={{ mb: 4 }}>
                Contact Us
              </Typography>
              <Typography variant="body1" sx={{ mb: 8 }}>
                Ready to take the next step? Get in touch with us today!
              </Typography>
              <Grid container spacing={4}>
                <Grid item xs={12} sm={6}>
                  <Card sx={{ p: 3, bgcolor: '#1a1a1a', textAlign: 'center' }}>
                    <Mail sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
                    <Typography variant="h6">Email Us</Typography>
                    <Typography component="a" href="mailto:geniusmileniaeducation@gmail.com" sx={{ color: 'primary.main' }}>
                      geniusmileniaeducation@gmail.com
                    </Typography>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Card sx={{ p: 3, bgcolor: '#1a1a1a', textAlign: 'center' }}>
                    <Phone sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
                    <Typography variant="h6">Call Us</Typography>
                    <Typography component="a" href="tel:+60192888254" sx={{ color: 'primary.main' }}>
                      +60192888254<br />
                    </Typography>
                    <Typography component="a" href="tel:+60192888424" sx={{ color: 'primary.main' }}>
                      +60192888424<br />
                    </Typography>
                    <Typography component="a" href="tel:+60197783518" sx={{ color: 'primary.main' }}>
                      +60197783518<br />
                    </Typography>
                  </Card>
                </Grid>
                <Grid item xs={12}>
                  <Card sx={{ p: 3, bgcolor: '#1a1a1a', textAlign: 'center' }}>
                    <LocationOn sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
                    <Typography variant="h6">Visit Us</Typography>
                    <Typography variant="h6" sx={{ mt: 3 }}>Pusat Tuisyen Genius Milenia @ PJCC (HQ)</Typography>
                    <Typography>
                      No 1, 1, Jalan PJS 5/30,<br />Taman Medan, 46000 Petaling Jaya,<br />Selangor
                    </Typography>
                    <Typography variant="h6" sx={{ mt: 3 }}>Pusat Tuisyen Genius Milenia @ Pantai Dalam (Cawangan)</Typography>
                    <Typography>
                      No 17-1, Jalan Pantai Murni 6,<br />Pantai Dalam, 59200 Kuala Lumpur,<br />Wilayah Persekutuan Kuala Lumpur
                    </Typography>
                  </Card>
                </Grid>
              </Grid>
            </Container>
          </Box>
        );

      default:
        return null;
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet" />

      <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default', display: 'flex', flexDirection: 'column' }}>
        {/* Transparent Navbar */}
        <AppBar
          position="absolute"
          sx={{
            background: 'rgba(0,0,0,0.3)',
            backdropFilter: 'blur(10px)',
            boxShadow: 'none',
            color: 'white',
          }}
        >
          <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 2, md: 6 }, py: 2 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: 'primary.main',
                cursor: 'pointer',
              }}
              onClick={() => setCurrentPage('home')}
            >
              Genius Milenia Education
            </Typography>
            <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2 }}>
              {['home', 'about', 'services', 'contact'].map((page) => (
                <Button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  sx={{
                    color: 'white',
                    '&:hover': { color: 'primary.main' },
                  }}
                >
                  {page.charAt(0).toUpperCase() + page.slice(1)}
                </Button>
              ))}
              <Button
                onClick={() => {
                  // navigation("/Portal")
                }}
                sx={{ color: 'white', '&:hover': { color: 'primary.main' } }}
              >
                Portal
              </Button>
            </Box>
            {/* Mobile Menu Button */}
            <IconButton
              sx={{ display: { xs: 'block', md: 'none' }, color: 'white' }}
              onClick={() => setMobileOpen(true)}
            >
              <Menu />
            </IconButton>
          </Toolbar>
        </AppBar>

        {/* 📱 MOBILE DRAWER MENU */}
        <Drawer
          anchor="right"
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          PaperProps={{
            sx: {
              bgcolor: '#121212',
              color: 'white',
              width: 220,
              pt: 2,
            },
          }}
        >
          <List>
            {['home', 'about', 'services', 'contact'].map((page) => (
              <ListItem key={page} disablePadding>
                <ListItemButton
                  onClick={() => {
                    setCurrentPage(page);
                    setMobileOpen(false);
                  }}
                >
                  <ListItemText primary={page.charAt(0).toUpperCase() + page.slice(1)} />
                </ListItemButton>
              </ListItem>
            ))}
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => {
                  // navigation("/Portal");
                  // setMobileOpen(false);
                }}
              >
                <ListItemText primary="Portal" />
              </ListItemButton>
            </ListItem>
          </List>
        </Drawer>

        {/* Main Content */}
        <Box component="main" sx={{ pt: currentPage === 'home' ? 0 : { xs: '56px', sm: '64px' } }}>{renderContent()}</Box>

        {/* Footer */}
        <Box sx={{ bgcolor: '#0b0b0b', py: 4, mt: 'auto', textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} Genius Milenia Education. All rights reserved.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            No 1, 1, Jalan PJS 5/30, Taman Medan,<br />46000 Petaling Jaya, Selangor
          </Typography>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default Webpage;
